import type { MotionProps } from 'framer-motion';
import type { ModalBackdropConfig } from '@/contexts/layout/modal-stack-types';

export const CSTRETCHMODAL_DEBUG_COMPONENT = 'Cstretchmodal/mobile-modal-stack';
export const CSTRETCHMODAL_OVERFLOW_HIDDEN = 'hidden';
export const CSTRETCHMODAL_BOX_SHADOW = [
  'rgba(0, 0, 0, 0.05) 1px 3px 5px 0px',
  'rgba(255, 255, 255, 0.06) 1px 1px 2px 1px inset',
  'rgba(0, 0, 0, 0.17) 2px 3px 30px 0px inset',
  'rgba(255, 255, 255, 0.03) -1px -2px 0px 0px inset',
  'rgba(0, 0, 0, 0.11) -1px -1px 2px 0px inset',
  'rgba(255, 255, 255, 0.05) 0px 0px 0px 1px inset',
].join(', ');
export const STRETCH_BACKDROP: ModalBackdropConfig = {
  opacity: 0.7,
  blur: 12,
  useGradient: true,
};

export const MOBILE_CONTAINER_MARGIN = '1rem';
export const DESKTOP_CONTAINER_MARGIN = '2rem';
export const MOBILE_CONTAINER_PADDING = '1.8rem 1.5rem';

export const MOBILE_SECTION_SPACING = 12;
export const DESKTOP_SECTION_SPACING = 16;
export const MOBILE_FLOATING_FOOTER_BOTTOM = 24;
export const DESKTOP_FLOATING_FOOTER_BOTTOM = 32;
export const MOBILE_BACK_BUTTON_INSET = '2rem';
export const DESKTOP_BACK_BUTTON_INSET = '3rem';

const MODAL_Y_OFFSET = 32;
const STRETCH_MODAL_EASE: [number, number, number, number] = [0.4, 0, 0.2, 1];

export const STRETCH_OVERLAY_MOTION_PROPS: Pick<MotionProps, 'initial' | 'animate' | 'exit'> = {
  initial: { opacity: 0 },
  animate: {
    opacity: 1,
    transition: { duration: 0.2, ease: STRETCH_MODAL_EASE },
  },
  exit: {
    opacity: 0,
    transition: { delay: 0.15, duration: 0.35, ease: STRETCH_MODAL_EASE },
  },
};

export const STRETCH_MODAL_MOTION_PROPS: Pick<MotionProps, 'initial' | 'animate' | 'exit'> = {
  initial: { opacity: 0, y: MODAL_Y_OFFSET },
  animate: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.35, ease: STRETCH_MODAL_EASE },
  },
  exit: {
    opacity: 0,
    y: MODAL_Y_OFFSET,
    transition: { duration: 0.35, ease: STRETCH_MODAL_EASE },
  },
};
